import script from "./CorrectableInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./CorrectableInput.vue?vue&type=script&lang=ts&setup=true"

import "./CorrectableInput.vue?vue&type=style&index=0&id=49cefe03&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cefe03"]])

export default __exports__